import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-39940cac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-sm-12" }

import { ref, inject, watch, Ref } from "vue";
import { debug as d } from "debug";
import { useAxios } from "../../composables/api";
import { CompositeHeadApiModel } from "../../api-models";
import HeadCanvas from "./3d/head-canvas.vue";
import HeadToolbar from "./3d/head-toolbar.vue";
import { transitionMilliseconds } from "./3d/use-nodes-and-links-graph";


export default /*#__PURE__*/_defineComponent({
  __name: 'composite-adhoc-group-head',
  setup(__props) {

const debug = d("cs.CompositeAdhocGroupHead");

// const props = defineProps<{
//   name: string;
//   userIds: string;
//   initialSoloOrViewpoints: SoloOrViewpointsOption;
// }>();

const headData = inject<Ref<CompositeHeadApiModel>>("groupHeadData");

const element = ref<HTMLElement>();
const isLoading = ref<boolean>(true);
const isExpanded = ref<boolean>(false);

watch(
  () => headData?.value,
  (newValue) => {
    if (newValue) isLoading.value = false;
  },
);

function onExpand() {
  isExpanded.value = true;
  element.value!.classList.add("expanded");
  element.value!.classList.remove("collapsed");
}

function onCollapse() {
  isExpanded.value = false;
  // Delay resize to allow animation to happen
  setTimeout(() => {
    element.value!.classList.add("collapsed");
    element.value!.classList.remove("expanded");
  }, transitionMilliseconds);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "adhoc-group-head",
        ref_key: "element",
        ref: element
      }, [
        (_unref(headData))
          ? (_openBlock(), _createBlock(HeadCanvas, {
              key: 0,
              expanded: isExpanded.value,
              model: _unref(headData)
            }, null, 8, ["expanded", "model"]))
          : _createCommentVNode("", true),
        _createVNode(HeadToolbar, {
          expanded: isExpanded.value,
          model: _unref(headData),
          onExpand: onExpand,
          onCollapse: onCollapse
        }, null, 8, ["expanded", "model"])
      ], 512)
    ])
  ]))
}
}

})